import React from 'react'
import { connect } from 'react-redux'
import { socialSignIn } from '../actions/users'

class SocialLogin extends React.Component {
  render() {
    const pathParams = this.props.location.hash
    const params = pathParams.split('&')
    const access_token = params[0].split('=')[1]
    const id_token = params[1].split('=')[1]

    this.props.dispatch(socialSignIn({ access_token, id_token }))

    return <div />
  }
}

export default connect()(SocialLogin)
